import React from "react";
import CmsLegalPage from "./CmsLegalPage";

export default function Terms() {
    return <CmsLegalPage page="legal_terms" fallbackTitle="Terms of Service" fallbackUpdated="23 February 2026" />;
}
